'use client'

import { destinationSchema } from '@server/schemas'
import { useTranslation } from '@shared/config/i18n'
import { captureClientException } from '@shared/libs/logger/client-error-capture'
import { PageContent } from '@shared/ui'
import Image from 'next/image'
import { useEffect } from 'react'

import { ButtonV1, Typography, VStack } from '@podo-app/design-system-temp'

const InternalError = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
  const t = useTranslation()

  useEffect(() => {
    captureClientException(error, { source: 'error-boundary:internal' })
  }, [error])

  return (
    <VStack as={PageContent} className="h-dvh items-center justify-center gap-7">
      <Image src="/images/error.png" alt="podo crying" width={100} height={100} />
      <Typography size="body1" className="text-gray-500 text-center">
        {t('common.errors.internalLine1')}
        <br />
        {t('common.errors.internalLine2')}
      </Typography>
      <VStack className="w-full gap-3 px-5">
        <ButtonV1
          onClick={() => {
            location.href = `/login?destination=${destinationSchema.enum.HOME}`
          }}
        >
          {t('common.auth.login')}
        </ButtonV1>
        <ButtonV1 variant="ghost" onClick={() => reset()}>
          {t('common.actions.retry')}
        </ButtonV1>
      </VStack>
    </VStack>
  )
}

export default InternalError
